import React, { useEffect, useState } from "react";

import { Dialog } from "primereact/dialog";
import { Sparklines, SparklinesBars, SparklinesLine } from "react-sparklines";
import { T } from "services/lang/LanguageService";
import DatasetLineChart from "../charts/dataset-line-chart/DatasetLineChart";
import SparkLineChart from "../sparkline-advanced/SparkLineChart";
import SparkLineLabel from "./SparkLineLabel";
import { ISparkLineHandlerProps, ValueLabel } from "./SparkLineTypes";

const SparkLineHandler = (props: ISparkLineHandlerProps) => {
  const value = props.dataArray[props.dataArray.length - 1];
  const decimalPlaces = props.decimalPlaces || 0;

  const [dialog, setDialog] = useState<boolean>(false);
  const [valueLabel, setValueLabel] = useState<ValueLabel>({
    disconnected: false,
    value,
    decimalPlaces,
    content: `${value?.toFixed(decimalPlaces)} ${props.unit ?? ""}`,
    bgColor: "rgba(255, 255, 255, 0.6)",
    textColor: "inherit",
  });

  useEffect(() => {
    setValueLabel(prev => ({
      ...prev,
      value,
      decimalPlaces,
      content: `${value?.toFixed(decimalPlaces)} ${props.unit ?? ""}`,
    }));
  }, [value, decimalPlaces, props.unit]); 

  const sparklineWidth = props.sparklineWidth || "300px";

  let el;
  if (props.dataArray && props.dataArray.length !== 0) {
    el = (
      <>
        {props.advanced ? (
          <SparkLineChart
            dataArray={props.dataArray}
            advancedProps={props.advancedProps!}
            lineColor={props.lineColor}
            lineWidth={props.lineWidth}
            setValueLabel={setValueLabel}
          />
        ) : (
          <div
            style={{
              lineHeight: "2rem",
              width: sparklineWidth,
              height: "40px",
              display: "inline-block",
            }}
          >
            <Sparklines data={props.dataArray} height={30} preserveAspectRatio="none">
              <SparklinesLine
                style={{
                  stroke: props.lineColor ?? "#41c3f9",
                  fill: "none",
                  strokeWidth: props.lineWidth ?? 1,
                }}
              />
              <SparklinesBars style={{ fill: props.lineColor ?? "#41c3f9", fillOpacity: ".25" }} />
            </Sparklines>
          </div>
        )}
        <SparkLineLabel valueLabel={valueLabel} setValueLabel={setValueLabel} {...props} />
      </>
    );
  } else {
    el = <h4>{T("word.no-data")}</h4>;
  }

  const identifiers = [
    props.dataset,
    props.advancedProps?.baseline?.usage === "dataset" && props.advancedProps?.baseline?.dataset,
    props.advancedProps?.maxLine?.usage === "dataset" && props.advancedProps?.maxLine?.dataset,
    props.advancedProps?.minLine?.usage === "dataset" && props.advancedProps?.minLine?.dataset,
  ].filter(Boolean) as string[];

  return (
    <>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-evenly",
          position: "relative",
          height: `${props.height ?? "auto"}px`,
        }}
        onDoubleClick={() => setDialog(true)}
      >
        {el}
      </div>

      <Dialog
        header={T("label.scada-tags-chart")}
        visible={dialog}
        style={{ width: "min(100vw, 1000px)", height: "500px" }}
        modal={false}
        onHide={() => {
          setDialog(false);
        }}
      >
        <DatasetLineChart
          title=""
          identifiers={identifiers}
          showDateSelection
          dynamicHeight
          chartDialogOpen={dialog}
        />
      </Dialog>
    </>
  );
};

export default SparkLineHandler;
